
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ExportState {
  isExporting: boolean;
  error: string | null;
}

const initialState: ExportState = {
  isExporting: false,
  error: null,
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    startExport: (state) => {
      state.isExporting = true;
      state.error = null;
    },
    exportSuccess: (state) => {
      state.isExporting = false;
      state.error = null;
    },
    exportFailure: (state, action: PayloadAction<string>) => {
      state.isExporting = false;
      state.error = action.payload;
    },
  },
});

export const { startExport, exportSuccess, exportFailure } = exportSlice.actions;
export default exportSlice.reducer;
